import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { clsx } from 'clsx'

interface ChatOverflowMenuItemProps {
  name: string
  icon: React.ComponentType<{ className?: string; width?: number | string; height?: number | string }>
  onClick: () => void
  destructive?: boolean
}

export const ChatOverflowMenuItem: React.FC<ChatOverflowMenuItemProps> = ({ name, icon: Icon, onClick, destructive = false }) => {
  return (
    <DropdownMenu.Item
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      className={clsx(
        'group flex items-center gap-2.5 p-2 rounded-md text-sm leading-6 w-full focus:outline-none cursor-pointer',
        destructive ? 'hover:bg-red-50 focus:bg-red-50' : 'hover:bg-brand-neutral-100 focus:bg-brand-neutral-100'
      )}
    >
      <Icon
        className={clsx(
          'w-4 h-4 shrink-0',
          destructive
            ? 'text-red-700 group-hover:text-red-800 group-focus:text-red-800 group-data-[highlighted]:text-red-800'
            : 'text-brand-neutral-600 group-hover:text-brand-950 group-focus:text-brand-950 group-data-[highlighted]:text-brand-950'
        )}
      />
      <span
        className={clsx(
          'whitespace-nowrap',
          destructive
            ? 'text-red-700 group-hover:text-red-800 group-focus:text-red-800 group-data-[highlighted]:text-red-800'
            : 'text-brand-neutral-700 group-hover:text-brand-950 group-focus:text-brand-950 group-data-[highlighted]:text-brand-950'
        )}
      >
        {name}
      </span>
    </DropdownMenu.Item>
  )
}
